import CommonPage from "./Common"
import ProvidersPage from "./Providers"
import UsersPage from "./Users"
import UsersArchivePage from "./UsersArchive"


const SettingsAdminPages = {
    Providers: ProvidersPage,
    Users: UsersPage,
    Common: CommonPage,
    UsersArchive: UsersArchivePage,
}

export default SettingsAdminPages